import { apiFetch } from './client';

export interface NotificationRecord {
  id: string;
  subject: string;
  sentBy: string;
  sentAt: string;
  recipientCount: number;
  failedCount: number;
  versionId?: string;
}

export interface SendNotificationRequest {
  subject: string;
  htmlBody: string;
  versionId?: string;
}

export interface SendNotificationResponse {
  id: string;
  sentAt: string;
  recipientCount: number;
  failedCount: number;
}

export const sendNotification = (body: SendNotificationRequest) =>
  apiFetch<SendNotificationResponse>('/api/v1/notifications', {
    method: 'POST',
    body: JSON.stringify(body),
  });

export const listNotifications = () =>
  apiFetch<{ items: NotificationRecord[] }>('/api/v1/notifications');
